import { SVGProps } from 'react'

export const ShieldCheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 12.5L11 14.5L15.5 10M9.40073 2.65522L5.85055 4.23307C4.81875 4.69164 4.30286 4.92093 3.92457 5.28336C3.59019 5.60373 3.33451 5.99715 3.17756 6.43283C3 6.92571 3 7.49026 3 8.61937V14.0748C3 15.3271 3 15.9532 3.1726 16.5216C3.32541 17.0247 3.57592 17.4928 3.90982 17.8991C4.28697 18.358 4.80796 18.7053 5.84992 19.3999L9.33744 21.7249C10.2997 22.3664 10.7808 22.6872 11.3009 22.8118C11.7605 22.922 12.2395 22.922 12.6991 22.8118C13.2192 22.6872 13.7003 22.3664 14.6626 21.7249L18.1501 19.3999C19.192 18.7053 19.713 18.358 20.0902 17.8991C20.4241 17.4928 20.6746 17.0247 20.8274 16.5216C21 15.9532 21 15.3271 21 14.0748V8.61937C21 7.49026 21 6.92571 20.8224 6.43283C20.6655 5.99715 20.4098 5.60373 20.0754 5.28336C19.6971 4.92093 19.1812 4.69164 18.1495 4.23307L14.5993 2.65522C13.6421 2.22982 13.1635 2.01711 12.666 1.93311C12.2251 1.85865 11.7749 1.85865 11.334 1.93311C10.8365 2.01711 10.3579 2.22982 9.40073 2.65522Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
